<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="none" viewBox="0 0 8 8"><path stroke="#FF5924" d="m1.5 7 6-6.5M2 .5h5.5V6"/></svg>
</template>

<script>
export default {
  name: "HintArrow"
}
</script>